import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { SleepProfileFormValues } from "./interface";

const boolLabel = (val: string) => {
  if (val === "YES") return "Yes";
  if (val === "NO") return "No";
  return val || "-";
};

interface ViewFieldsProps {
  formValues: SleepProfileFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Notable sleep concerns" value={formValues.notableSleepConcerns} />
      <LabeledText label="Bedtime routine" value={formValues.bedtimeRoutine} />
      <LabeledText label="Does the client sleep throughout the night?" value={boolLabel(formValues.sleepsThroughNight)} />
      <LabeledText label="Does the client take naps regularly?" value={boolLabel(formValues.takesNapsRegularly)} />
      <LabeledText label="If they wake up, do they get out of bed?" value={boolLabel(formValues.wakesAndGetsOut)} />
      <LabeledText label="If they wake up, do they seek out an adult?" value={boolLabel(formValues.wakesAndSeeksAdult)} />
    </Grid>
  );
};

export default ViewFields;
